/**
 * Variant Description Updater v2.0
 * Enfoque: Mapa JSON + Event Delegation
 */
(function() {
  'use strict';

  const SELECTORS = {
    scriptData: '#variant-description-data',
    container: '.js-variant_description',
    productForm: 'form[action*="/cart/add"]' // Selector genérico para formas de Shopify
  };

  let descriptionMap = {};

  // 1. Cargar el mapa de datos desde el script Liquid
  function loadDescriptionMap() {
    const dataScript = document.querySelector(SELECTORS.scriptData);
    if (!dataScript) return false;
    
    try {
      descriptionMap = JSON.parse(dataScript.innerHTML);
      console.log('✅ [VariantDesc] Mapa cargado:', Object.keys(descriptionMap).length, 'variantes');
      return true;
    } catch (e) {
      console.error('❌ [VariantDesc] Error parseando JSON:', e);
      return false;
    }
  }

  // 2. Actualizar el DOM basado en el ID
  function updateUI(variantId) {
    const container = document.querySelector(SELECTORS.container);
    // const paragraph = document.querySelector(SELECTORS.paragraph); <-- BORRAR
    
    if (!container) return;

    const idStr = String(variantId);
    const descriptionHTML = descriptionMap[idStr]; // Ahora esto es HTML string, no objeto

    if (descriptionHTML) {
      // Inyectamos el HTML directamente en el contenedor
      container.innerHTML = descriptionHTML;
      container.style.display = 'block';
    } else {
      container.innerHTML = '';
      container.style.display = 'none';
    }
  }

  // 3. Obtener el ID de la variante actual
  function getCurrentVariantId() {
    // Método A: Intentar leer de la URL (más fiable en temas modernos)
    const params = new URLSearchParams(window.location.search);
    const urlId = params.get('variant');
    if (urlId) return urlId;

    // Método B: Fallback buscando el input hidden llamado "id" dentro del form
    // Muchos temas actualizan este input automáticamente
    const form = document.querySelector(SELECTORS.productForm);
    if (form) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) return idInput.value;
    }
    
    return null;
  }

  function init() {
    if (!loadDescriptionMap()) return;

    // Listener Global para cualquier cambio en el formulario del producto
    // Usamos 'change' que burbujea desde los radio buttons o selects
    const productForm = document.querySelector(SELECTORS.productForm) || document.body;

    productForm.addEventListener('change', function(e) {
      // Pequeño timeout para permitir que el JS del tema actualice la URL o el input ID
      setTimeout(() => {
        const currentId = getCurrentVariantId();
        if (currentId) {
          console.log('🔄 [VariantDesc] Cambio detectado. ID:', currentId);
          updateUI(currentId);
        }
      }, 50); 
    });

    // Soporte especial para Shopify Dawn/Themes 2.0 que usan custom events
    // Muchos temas disparan 'variant:change'
    document.addEventListener('variant:change', function(e) {
       if (e.detail && e.detail.variant) {
         updateUI(e.detail.variant.id);
       }
    });
  }

  // Arranque
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();